/**
 * Seletores dos containers de overlay que o Angular e suas libs anexam
 * diretamente ao <body>, fora do elemento host. Esses elementos sobrevivem ao
 * moduleRef.destroy() quando o componente que os criou não os fechou, e vazam
 * para a tela React. A lista é fixa e específica do Angular/Bootstrap/toastr
 * para não atingir portais do React/MUI (ex.: .MuiModal-root).
 */
export const ANGULAR_OVERLAY_SELECTORS = [
  '.cdk-overlay-container',
  '.cdk-overlay-backdrop',
  'ngb-modal-window',
  'ngb-modal-backdrop',
  '.modal-backdrop',
  '.toast-container',
  '#toast-container',
] as const;

/**
 * Rede de segurança que remove do documento os overlays órfãos do Angular.
 * Escopada por seletor — não remove nada que pertença ao React.
 */
export function cleanupAngularOverlays(): void {
  ANGULAR_OVERLAY_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => el.remove());
  });
}

/**
 * Reverte as alterações de layout que libs de modal aplicam ao <body>
 * (trava de scroll), evitando que a tela React fique sem scroll após um
 * modal Angular ter sido aberto.
 */
export function resetBodyLayout(): void {
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
}
